import type { DropdownProps } from 'antd';
import { Dropdown } from 'antd';
import React from 'react';
import classNames from 'classnames';
import styles from './index.less';

export type HeaderDropdownProps = {
  overlayClassName?: string;
  overlay?: React.ReactNode | (() => React.ReactNode) | any;
  menu?: DropdownProps['menu'];
  placement?: 'bottomLeft' | 'bottomRight' | 'topLeft' | 'topCenter' | 'topRight' | 'bottomCenter';
} & Omit<DropdownProps, 'overlay' | 'menu'>;

const HeaderDropdown: React.FC<HeaderDropdownProps> = ({ 
  overlayClassName: cls, 
  overlay,
  ...restProps 
}) => {
  // Convert overlay to dropdownRender for Ant Design v6 compatibility
  const dropdownRender = overlay 
    ? () => (typeof overlay === 'function' ? overlay() : overlay)
    : undefined;

  return (
    <Dropdown 
      overlayClassName={classNames(styles.container, cls)} 
      dropdownRender={dropdownRender}
      {...restProps} 
    />
  );
};

export default HeaderDropdown;
